import PropTypes from 'prop-types';
import React from 'react';
import { connect } from 'react-redux';
import Bubble from '../../../components/common/Bubble';
import { getNotifications } from './selectors';

const Notifications = ({ notifications }) => (
  <div className="notifications">
    {notifications.map(
      ({ id, text, type }) => <Bubble key={id} text={text} type={type} />
    )}
  </div>
);

Notifications.propTypes = {
  notifications: PropTypes.object
};

const mapStateToProps = state => ({
  notifications: getNotifications(state)
});

export default connect(mapStateToProps)(Notifications);
